var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1451 5.35213C12.6753 5.35213 13.1051 4.92232 13.1051 4.39213C13.1051 3.86194 12.6753 3.43213 12.1451 3.43213C11.6149 3.43213 11.1851 3.86194 11.1851 4.39213C11.1851 4.92232 11.6149 5.35213 12.1451 5.35213Z",
    fill: "#8591A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5C5.794 12.5 4 10.706 4 8.5C4 6.294 5.794 4.5 8 4.5C10.206 4.5 12 6.294 12 8.5C12 10.706 10.206 12.5 8 12.5ZM8 6.5C6.897 6.5 6 7.397 6 8.5C6 9.603 6.897 10.5 8 10.5C9.103 10.5 10 9.603 10 8.5C10 7.397 9.103 6.5 8 6.5Z",
    fill: "#8591A5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5H4C1.944 16.5 0 14.556 0 12.5V4.5C0 2.444 1.944 0.5 4 0.5H12C14.056 0.5 16 2.444 16 4.5V12.5C16 14.556 14.056 16.5 12 16.5ZM4 2.5C3.065 2.5 2 3.565 2 4.5V12.5C2 13.453 3.047 14.5 4 14.5H12C12.935 14.5 14 13.435 14 12.5V4.5C14 3.565 12.935 2.5 12 2.5H4Z",
    fill: "#8591A5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.ae13fce9518a15a2ddc34cae332afd11.svg";
export { ForwardRef as ReactComponent };